import { render, staticRenderFns } from "./ReportComponent.vue?vue&type=template&id=6c99378e&scoped=true&"
import script from "./ReportComponent.vue?vue&type=script&lang=js&"
export * from "./ReportComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReportComponent.vue?vue&type=style&index=0&id=6c99378e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c99378e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c99378e')) {
      api.createRecord('6c99378e', component.options)
    } else {
      api.reload('6c99378e', component.options)
    }
    module.hot.accept("./ReportComponent.vue?vue&type=template&id=6c99378e&scoped=true&", function () {
      api.rerender('6c99378e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/ReportComponent.vue"
export default component.exports